import { useState } from 'react';
import { ReduxStore } from '../../../store/reducers';
import { ThunkDispatch } from 'redux-thunk';
import { SetUserObject } from '../../../store/actions/user/UserActions';
import { Auth } from 'aws-amplify';
import { connect } from 'react-redux';
import { RouteNames } from '../../../shared/enums/RouteNames';
import sharedHistory from '../../../shared/History';
import useLocalization from '../../../shared/useLocalization/useLocalization';
import { withNavBar } from '../../shared/NavBar/NavBar';
import { Modal } from '../../../shared/Modal/Modal';
import { PasswordInput } from '../../shared/PasswordInput/PasswordInput';
import './DeactivateAccount.scss';

export const FormIds = {
  cancelBtn: 'Cancel',
  deactivateBtn: 'DeactivateAccount',
	confirmCancelBtn: 'ConfirmCancel',
	confirmDeactivateBtn: 'ConfirmDeactivateAccount',
	password: 'Password'
};

const DeactivateAccount = ({userObject}: IDeactivateAccountProps) => {
	const local = useLocalization();
	const [password, setPassword] = useState('');
	const [passwordValidation, setPasswordValidation] = useState(
    {} as IFieldValidation
  );
	const [deactivateModal, setDeactivateModal] = useState<IModal>();

	const deactivateAccount = () => {
		deactivateModal?.open();
	}

	const handleCloseDeactivateAccount = () => {
		deactivateModal?.close();
	}

	const handleDeactivateAccount = async () => {
		try {
      if (userObject && userObject.attributes?.email) {
				// validate password
				await Auth.signIn(userObject.attributes.email, password);
				await Auth.deleteUser();
				await Auth.signOut({ global: true });

      	sharedHistory.push(RouteNames.DeactivateAccountSuccess);
      }
    } catch (authError: any) {
			setPasswordValidation((prev: IFieldValidation) => {
				return {class: 'deactivate-field-error', message: 'Invalid password'}
			});
    }
	}

	const deactivationConfirmationModal = <Modal onLoad={setDeactivateModal} confimationModal={true}>
		<div className='container' style={{textAlign: 'center'}}>
			<div className='row'>
				<h4>{local?.t('deactivateAccount.title')}</h4>
				<p>
				{local?.t('deactivateAccount.instructions')} {userObject.attributes?.email}
				</p>
			</div>
			<div className='row'>
				<div className='input-field'>
					<PasswordInput
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
							setPassword(e.target?.value || '');
						}}
						value={password}
						id={FormIds.password}
						testId={FormIds.password}
						aria-label={FormIds.password}
						inputClassName={passwordValidation.class}
						labelClassName={`${password ? 'active' : ''}`}
						helperText={passwordValidation.message}
					/>
					{
						passwordValidation.message ? <div className="deactivate-error">{passwordValidation.message}</div> : ''
					}
				</div>
			</div>
			<div className='row justify-content-center'>
				<div className='col s6'>
					<button data-testid={FormIds.confirmCancelBtn} className='btn-small button-secondary' onClick={handleCloseDeactivateAccount}>
						{local?.t('deactivateAccount.cancelButtonText')}
					</button>
				</div>
				<div className='col s6'>
					<button data-testid={FormIds.confirmDeactivateBtn} className='button-primary btn-small' onClick={handleDeactivateAccount}>
						{local?.t('deactivateAccount.confirmDeactivateButtonText')}
					</button>
				</div>
			</div>
		</div>
	</Modal>

  return (
    <div className="deactivate" data-testid="deactivate-account">
			<div className="row">
				<h4 className="row">{local?.t('deactivateAccount.title')}</h4>
				<h5 className="row">{local?.t('deactivateAccount.subTitle')}</h5>
				<div className="row">
					<p className="col s8">
						{local?.t('deactivateAccount.description')}
					</p>
					<div className="col s4">
						<button
							aria-label={FormIds.cancelBtn}
							className="btn btn-tertiary"
							onClick={sharedHistory.goBack}
						>
							{local?.t('deactivateAccount.cancelButtonText')}
						</button>
						<button
							aria-label={FormIds.deactivateBtn}
							data-testid={FormIds.deactivateBtn}
							className="btn btn-primary"
							onClick={deactivateAccount}
						>
							{local?.t('deactivateAccount.title')}
						</button>
					</div>
				</div>
      </div>
			{deactivationConfirmationModal}
    </div>
  );
};

const stateToProps = (state: ReduxStore) => {
  return { userObject: state.User.UserObject }
}

export default withNavBar(connect(stateToProps)(DeactivateAccount), true);